export type ContractItemOptions = {
  _id: string;
  value: string;
};

export type ContractSettingMasterDataField =
  | 'productNameId'
  | 'insurancePlanId'
  | 'insurancePremiumId'
  | 'premiumPaymentTermId'
  | 'premiumPaymentFrequencyId'
  | 'premiumPaymentYearId'
  | 'effectiveDateId'
  | 'riderCountId';

export type ContractSettingItem = {
  _id: string;
  productName: ContractItemOptions;
  insurancePlan: ContractItemOptions;
  insurancePremium: ContractItemOptions;
  premiumPaymentTerm: ContractItemOptions;
  premiumPaymentFrequency: ContractItemOptions;
  premiumPaymentYear: ContractItemOptions;
  riderCount: ContractItemOptions;
  effectiveDate: ContractItemOptions;
  commissionRate: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
};

export type ContractSettingFormValues = {
  productNameId: ContractItemOptions | undefined;
  insurancePlanId: ContractItemOptions | undefined;
  insurancePremiumId: ContractItemOptions | undefined;
  premiumPaymentTermId: ContractItemOptions | undefined;
  premiumPaymentFrequencyId: ContractItemOptions | undefined;
  premiumPaymentYearId: ContractItemOptions | undefined;
  effectiveDateId: ContractItemOptions | undefined;
  riderCountId: ContractItemOptions | undefined;
  commissionRate: number | null | undefined;
};

export type CreateUpdateContractSettingBody = {
  productNameId: string;
  insurancePlanId: string;
  insurancePremiumId: string;
  premiumPaymentTermId: string;
  premiumPaymentFrequencyId: string;
  premiumPaymentYearId: string;
  effectiveDateId: string;
  riderCountId: string;
  commissionRate: number | null | undefined;
};

export enum ContractDataFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}
